import { inject as service } from '@ember/service';
import { oneWay } from '@ember/object/computed';
import Route from 'cio/routes/base';

export default class BroadcastRoute extends Route {
  @service store;
  @service subscriptionCenter;

  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      model,
      path: this.routeName,
      name: oneWay('model.name'),
      helpLabel: 'API triggered broadcasts',
      helpUrl: 'https://customer.io/docs/journeys/broadcasts-in-customerio/#api-triggered-broadcasts',
    };
  }

  redirect(model) {
    if (!model.isApiTriggered) {
      this.router.transitionTo('campaigns.campaign', model.id);
    }
  }

  async beforeModel(transition) {
    await this.subscriptionCenter.initializeTask.perform();

    return super.beforeModel(transition);
  }

  model(params) {
    return this.store.findRecord('campaign', params.campaign_id);
  }
}
